import type {State} from 'src/reducers';
import type {SenseAiState} from 'src/reducers/sense-ai';


export const selectSenseAiData = (state: State): SenseAiState => state.senseAi;
